module.exports = __webpack_public_path__ + "static/img/computer.ac55217f.png";